import React, { createContext, useReducer } from 'react'
import PropTypes from 'prop-types'

const initialState = {
  packages: [],
  filteredPackages: [],
  current: null,
  count: null,
  destinations: [],
  durationToggles: null,
  destination: '',
  num_nights: 1,
  arrival_date: '',
  isLoading: false,
  toggleNoResults: false,
  lowestStay: 1
}

export const PACKAGES = {
  ALL: {
    SET: 'PACKAGES/ALL/SET'
  },
  FILTERED: {
    SET: 'PACKAGES/FILTERED/SET'
  },
  CURRENT: {
    SET: 'PACKAGES/CURRENT/SET'
  },
  COUNT: {
    SET: 'PACKAGES/COUNT/SET'
  },
  DESTINATIONS: {
    SET: 'PACKAGES/DESTINATIONS/SET'
  },
  SEARCH: {
    DESTINATION: 'PACKAGES/SEARCH/DESTINATION',
    NUM_NIGHTS: 'PACKAGES/SEARCH/NUM_NIGHTS',
    ARRIVAL_DATE: 'PACKAGES/SEARCH/ARRIVAL_DATE',
    LOADING: 'PACKAGES/SEARCH/LOADING',
    TOGGLE_NO_RESULTS: 'PACKAGES/SEARCH/TOGGLE_NO_RESULTS'
  },
  LOWEST_STAY: {
    SET: 'PACKAGES/LOWEST_STAY/SET'
  }
}

let reducer = ( state, action ) => {
  switch(action.type) {
    case "reset":
      return initialState
    case PACKAGES.ALL.SET:
      return { ...state, packages: action.payload }
    case PACKAGES.FILTERED.SET:
      return { ...state, filteredPackages: action.payload }
    case PACKAGES.CURRENT.SET:
      return { ...state, current: action.payload }
    case PACKAGES.COUNT.SET:
      return { ...state, count: action.payload }
    case PACKAGES.DESTINATIONS.SET:
      return { ...state, destinations: action.payload }
    case PACKAGES.SEARCH.DESTINATION:
      return { ...state, destination: action.payload }
    case PACKAGES.SEARCH.NUM_NIGHTS:
      return { ...state, num_nights: action.payload }
    case PACKAGES.SEARCH.ARRIVAL_DATE:
      return { ...state, arrival_date: action.payload }
    case PACKAGES.SEARCH.LOADING:
      return { ...state, isLoading: action.payload }
    case PACKAGES.SEARCH.TOGGLE_NO_RESULTS:
      return { ...state, toggleNoResults: action.payload }
    case PACKAGES.LOWEST_STAY.SET:
      return { ...state, lowestStay: action.payload }
    default:
      return state
  }
}

export const PackagesContext = createContext()

export const PackagesProvider = ({ children }) => {
  let [state, dispatch] = useReducer(reducer, initialState)
  let value = { state, dispatch }

  return (
    <PackagesContext.Provider value={ value }>
      { children }
    </PackagesContext.Provider>
  )
}

PackagesProvider.propTypes = {
  children: PropTypes.node
}

export const PackagesConsumer = PackagesContext.Consumer
